export default {
  buttons: {
    cancel: "İptal",
    dismiss: "Kapat",
    add_waypoint: "Gidilecek yer ekleyin"
  },
  distance: {
    value: "{distance, number, distance} {unit}",
    unit: {
      miles: "mil."
    }
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  search: {
    title: "Ara",
    placeholder: "Bir yer girin",
    enter_location: "Bir yer girin",
    help: {
      inactive: "Ara"
    }
  },
  filters: {
    title: "Filtreler",
    more: "Diğer Servis ve Hizmetler",
    less: "Filtreleri Kapat",
    group: {
      more: "Diğer",
      less: "Filtreleri Kapat"
    },
    amenities: {
      title: "Servis & Hizmetler"
    },
    fuels: {
      title: "Yakıt Tipleri"
    }
  },
  directions: {
    title: "Rota Planlayıcı",
    placeholder: {
      destination: "Bir yer girin",
      waypoint: "Bir yer girin"
    },
    route: {
      title: "Rota Seçenekleri",
      avoid_tolls: "Paralı Yollar Hariç",
      avoid_highways: "Otoyollar hariç",
      title_corridor: "Rotadan İstasyona Mesafe"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# gün} other {# günler}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# Dakika} other {# Dakika}}\
`,
    button: "Ara"
  },
  locations: {
    title: "Lokasyonlar",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} x {place}"
  },
  info_window: {
    title: "İstasyon Detayları",
    location_id: "Istasyon Kodu",
    services: "Servis & Hizmetler",
    nearby: "Yakınında",
    opening_hours: {
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Son güncelleme",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Rota Planlayıcı"
  },
  fuels: {
    autogas_lpg: "Shell AutoGas (LPG)",
    fuelsave_midgrade_gasoline: "Shell FuelSave Kurşunsuz",
    fuelsave_regular_diesel: "Shell FuelSave Diesel",
    premium_diesel: "Shell V-Power Diesel",
    premium_gasoline: "Shell V-Power Kurşunsuz"
  },
  amenities: {
    air_and_water: "Hava",
    cafe: "Kahve Dunyasi",
    carwash: "Yıkama",
    costa_express: "Kahve Dünyası",
    credit_card_american_express: "kredi Kartı - American Express",
    credit_card_diners_club: "Kredi Kartı - Diners",
    credit_card_mastercard: "Kredi Kartı-Mastercard",
    credit_card_visa: "Kredi Kartı-Visa",
    credit_card: "Kredi Kartı",
    fleet_card_dkv: "Filo Kart- DKV",
    fleet_card_eni: "Filo Kart- Eni",
    fleet_card_esso: "Filo Kart-Esso",
    fleet_card_general: "Filo Kart",
    fleet_card_uta: "Filo Kart-UTA",
    guarded_car_park: "Güvenlikli Park",
    hgv_lane: "Extra Mola",
    hot_food: "Sıcak Yemek",
    ido_ticket: "Ido Bilet",
    parking_lanes: "Park Alanı",
    pay_at_pump: "Pompada Ödeme",
    restaurant: "Restoran",
    self_service: "Self Servis",
    service_bay: "Shell Helix Motor Yağı Değişim Merkezi ",
    shop: "Market",
    shower: "Duş",
    snack_food: "Fast Food",
    standard_toilet: "Tuvalet",
    supermarket_fuel_discount: "Yakıt İndirimi",
    toilet: "Tuvalet",
    truck_parking: "Extra Mola İstasyonu ",
    twenty_four_hour: "24 Saat ",
    vacuum: "Süpürge",
    vehicle_identity_system: "Taşıt Tanıma Sistemi"
  },
  settings: {
    title: "Ayarlar",
    tooltip: "Ayarlar",
    distance_units: {
      title: "Mesafe",
      km: "kilometre",
      miles: "mil"
    },
    language: {
      title: "Dil"
    }
  }
}
